/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui'; // iui-state
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { getAnalytics } from 'state/actions/embedsState/embedAnalytics';
// component
import EmbedContent from 'pages/dashboard/embeds/analytics/embedcontent/embedcontent';



/* ========== ~~~~~~~~~~ PAGE : EMBED CONTENT : PARENT ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
        embedName: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedName,
        embedUUID: embedsState.embedAnalytics.selectedEmbedUUID,
        sortedContents: embedsState.embedManagementState.contentStatus.sortedContents,
        fetchingSortedContent: embedsState.embedManagementState.contentStatus.fetchingSortedContent,
        currentPage: embedsState.embedAnalytics.currentPage,
        totalRows: embedsState.embedAnalytics.totalRows,
        contents: embedsState.embedAnalytics.contents,
        fetchingAnalytics: embedsState.embedAnalytics.fetchingAnalytics,
        lastUpdatedAt: embedsState.embedAnalytics.lastUpdatedAt,
        embedAnalytics: embedsState.embedAnalytics
    });

// map actions
const mapDispatchToProps = dispatch => ({
	moveToPage: (location) => {
		dispatch(updatePageDetails(`dashboard/embeds/management/${location}`));
		dispatch(updateStepDetails(location));
    	dispatch(changePage(`dashboard/embeds/management/${location}`))
    },
    getAnalytics: (embedUUID, filters) => dispatch(getAnalytics(embedUUID, filters))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(EmbedContent);
